export enum ProlongationCalcState {
  CanExtend,
  WaitingSigning,
  WaitingPayment,
  CannotExtend,
  CannotExtend12HoursPrev,
  CannotExtend4DaysLoan
}
